import * as Library from '../../../core/library/index';

export class Error {
  public id: string | number;
  public message: string;
  public code: string | number;

  constructor();
  constructor(options: Object);
  constructor(options?: any) {
    this.id = Library.init(options, 'id', 0);
    this.message = Library.init(options, 'message');
    this.code = Library.init(options, 'code');
  }
}
